import { useTranslation } from "react-i18next";
import style from "./ContinueWatchingStatistics.module.css";
import Icon from "@/ui/icon/Icon";
import CircularProgress from "@/ui/circularProgress/CircularProgress";
import { useMediaQuery } from "@/hooks/useMediaQuery";

function ContinueWatchingStatistics({ courseProgress }) {
	const { t } = useTranslation();
	const isMobile = useMediaQuery("(max-width: 800px)");
	const total_units =
		courseProgress.total_videos + courseProgress.total_quizzes;
	const units_completed =
		courseProgress.videos_completed + courseProgress.quizzes_completed;

	const units_percent = Math.round((100 * units_completed) / total_units);

	if (isMobile) {
		return (
			<div className={`${style.statistics} ${style.mobile}`}>
				<CircularProgress
					progress={units_percent / 100}
					color="var(--primary)"
					radius={35}
					stroke={7}
				>
					<div className={style.percent}>
						<span>{units_percent}</span>
						<span>%</span>
					</div>
				</CircularProgress>
				<div className={style.progressInfo}>
					<div className={style.individualProgress}>
						<span className={style.label}>{t("courses:statistics.video")}</span>
						<div className={style.progress}>
							<span>{courseProgress.videos_completed}</span>
							<span>
								<Icon icon="fa-slash-forward" />
							</span>
							<span>{courseProgress.total_videos}</span>
						</div>
					</div>
					<div className={style.individualProgress}>
						<span className={style.label}>{t("courses:statistics.quiz")}</span>
						<div className={style.progress}>
							<span>{courseProgress.quizzes_completed}</span>
							<span>
								<Icon icon="fa-slash-forward" />
							</span>
							<span>{courseProgress.total_quizzes}</span>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={style.statistics}>
			<CircularProgress
				progress={units_percent / 100}
				color="var(--primary)"
				radius={94}
				stroke={16}
			>
				<div className={style.content}>
					<div className={style.percent}>
						<span>{units_percent}</span>
						<span>%</span>
					</div>
					<div className={style.progress}>
						<span>{units_completed}</span>
						<span>
							<Icon icon="fa-slash-forward" />
						</span>
						<span>{total_units}</span>
					</div>
				</div>
			</CircularProgress>
			<div className={style.progressInfo}>
				<div className={style.individualProgress}>
					<div className={style.percent}>
						<span>
							{courseProgress.total_videos > 0
								? Math.round(
										(100 *
											courseProgress.videos_completed) /
											courseProgress.total_videos
									)
								: 100}
						</span>
						<span>%</span>
					</div>
					<span className={style.label}>{t("courses:statistics.video")}</span>
				</div>
				<div className={style.individualProgress}>
					<div className={style.percent}>
						<span>
							{courseProgress.total_quizzes > 0
								? Math.round(
										(100 *
											courseProgress.quizzes_completed) /
											courseProgress.total_quizzes
									)
								: 100}
						</span>
						<span>%</span>
					</div>
					<span className={style.label}>{t("courses:statistics.quiz")}</span>
				</div>
			</div>
		</div>
	);
}

export default ContinueWatchingStatistics;
